import Category from '@/Models/Category'
import categoriesFilters from '@/views/Categories/Data/categoriesFilters'
import _remove from 'lodash/remove'

const getDefaultState = () => ({
  categories: { data: [], current_page: 1, total: 0, last_page: 0 },
  filters: JSON.parse(JSON.stringify(categoriesFilters)),
  loading: false,
})

const state = getDefaultState()

const actions = {

  async fetchCategories({ commit }, page) {
  try {
    commit('setLoading', true)

    let q = Category.params({ page })
    const name = (state.filters.name || '').trim()
    const sector = (state.filters.sector || '').toString().trim()

    if (name) q = q.where('name', name)
    if (sector) q = q.where('sector.name', sector)

    const response = await q.get()
    commit('setCategories', response)
    return response
  } catch (error) {
    return error
  } finally {
    commit('setLoading', false)
  }
},


  filterCategories({ commit, dispatch }, filters) {
    commit('setCurrentPage', 1)
    commit('setFilters', filters)
    dispatch('fetchCategories', state.categories.current_page)
  },

  async storeCategory({ dispatch }, payload) {
    const category = new Category(payload)
    const response = await category.save()
    dispatch('fetchCategories', state.categories.current_page)

    return new Category(response)
  },

  async updateCategory({ dispatch }, payload) {
    const category = new Category(payload)
    const response = await category.save()
    dispatch('fetchCategories', state.categories.current_page)

    return response
  },

  async destroyCategory({ dispatch, commit }, categoryId) {
    const category = new Category({ id: categoryId })
    const response = await category.delete()
    commit('deleteCategory', categoryId)

    commit('setCurrentPage', state.categories.data.length ? state.categories.current_page : state.categories.current_page - 1)

    if (state.categories.data.length) {
      dispatch('fetchCategories', state.categories.current_page)
    }

    return response
  },
}

const mutations = {
  resetState(data) {
    Object.assign(data, getDefaultState())
  },

  setCategories(state, data) {
    state.categories = data
  },

  setCurrentPage(state, page) {
    state.categories.current_page = page
  },

  setLoading(state, value) {
    state.loading = value
  },

  deleteCategory(state, categoryId) {
    _remove(state.categories.data, { id: categoryId })
  },

  setFilters(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },
}

const getters = {
  getCategories: state => state.categories.data,
  getTotal: state => state.categories.total,
  getLastPage: state => state.categories.last_page,
  getFilters: state => state.filters,
  getCurrentPage: state => state.categories.current_page,
  getLoading: state => state.loading,
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
